import { render, staticRenderFns } from "./custom-icon-checked.vue?vue&type=template&id=6b5f4bd7"
import script from "./custom-icon-checked.vue?vue&type=script&lang=js"
export * from "./custom-icon-checked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports